module.exports = __webpack_public_path__ + "static/img/logo-txt.10b312a7.png";